const home = {
  title: 'Domov',
  language: 'Jezik',
  allLanguages: 'Vsi jeziki',
  languageFilter: 'Filtriraj po jeziku',
  languagesSelected: '{{count}} izbranih',
  languages: {
    en: 'Angleščina',
    sl: 'Slovenščina',
    hr: 'Hrvaščina',
  },

  loadingTemplates: 'Nalagam predloge...',
  noTemplates: 'Ni predlogov',
  noTemplatesForLanguage: 'Ni predlog za ta jezik',
  noTemplatesForLanguageDescription:
    'Za začetek, ustvarite predlogo v tem jeziku.',
  selectTemplate: 'Izberite predlogo',
  selectTemplateDescription: 'Katero predlogo želite uporabiti za narek?',

  start: 'Začni narek',
  dropAudioHere: 'Spustite avdio datoteko tukaj',
  uploadAudio: 'Naloži zvok',
  uploadAndGenerate: 'Naloži in generiraj',
  uploading: 'Nalaganje...',
  uploadingAndGenerating: 'Nalaganje...',
  stop: 'Ustavi',
  saving: 'Shranjujem...',
  delete: 'Izbriši',

  resume: 'Nadaljuj narek',
  cancel: 'Prekliči',
  continue: 'Nadaljuj',
  transcription: 'Narek',
  transcriptionEmpty: 'Še ni prepisa',
  segmentBreaks: 'Prelomi segmentov',
  paused: 'Pavzirano',
  extractData: 'Pripravi izvid',
  extractingData: 'Generiram podatke',
  extractingDataDescription: 'To ne bi smelo trajati dolgo...',
  transcribingData: 'Prepisovanje',
  transcribingDataDescription: 'Pretvarjanje zvoka v besedilo...',

  errorLoadingTemplates: 'Pri nalaganju predlog je prišlo do napake',
  retry: 'Poskusi znova',
  createTemplate: 'Ustvari predlogo',

  stats: {
    word: 'beseda',
    words: 'besed',
    character: 'znak',
    characters: 'znakov',
    token: 'žeton',
    tokens: 'žetonov',
  },

  sectionGuidance: {
    analyzing: 'Analiziram...',
    suggestion: 'Predlog',
    analysisFailed: 'Analiza oddelkov ni uspela',
    analysisFailedDescription:
      'Oddelkov ni mogoče analizirati. Snemanje se bo nadaljevalo.',
  },

  errors: {
    networkNotConnected: {
      title: 'Ni internetne povezave',
      description: 'Za uporabo aplikacije je potrebna internetna povezava.',
    },
    get_user_media_failed: {
      title: 'Dostop do mikrofona zavrnjen',
      description:
        'Za nadaljevanje v nastavitvah brskalnika dovolite dostop do mikrofona.',
    },
    api_key_fetch_failed: {
      title: 'Preverjanje pristnosti ni uspelo',
      description:
        'Vaše seje nismo mogli preveriti. Osvežite stran in poskusite znova.',
    },
    queue_limit_exceeded: {
      title: 'Nestabilna omrežna povezava',
      description:
        'Vaša internetna povezava je prepočasna za nalaganje zvoka v realnem času. Prepisovanje je prekinjeno.',
    },
    websocket_error: {
      title: 'Povezava prekinjena',
      description:
        'Povezava s strežnikom za prepisovanje je izgubljena. Preverite svojo internetno povezavo.',
    },
    media_recorder_error: {
      title: 'Napaka pri snemanju',
      description:
        'Brskalnik je nepričakovano prekinil snemanje. Poskusite znova.',
    },
    api_error: {
      title: 'Strežniška napaka',
      description: 'Storitev za prepisovanje je sporočila napako: {{message}}',
    },
    default: {
      title: 'Prišlo je do napake',
      description: 'Nekaj je šlo narobe. Poskusite znova.',
    },
  },
};

export default home;
